import { cn } from '@bazaar-marketplace/utils';
import { createElement } from 'react';

import type { TypographyProps } from './types';
import { typographyVariants } from './variants';

export const Typography = ({ children, tag = 'span', size = 'md', weight, className }: TypographyProps) =>
  createElement(
    tag,
    {
      className: cn(typographyVariants({ size, weight }), className),
    },
    children,
  );
